var safeString = {
  exports: {}
};

export { safeString as s };
//# sourceMappingURL=safe-string.js.map
